import { EStockAvailability } from '@model';

import { IProduct } from '../model';

/**
 * Gets a flag whether a product is disabled (e.g. not available)
 * @param product
 */
export const isProductDisabled = (product: IProduct): boolean =>
  product.stockAvailability === EStockAvailability.OUT_OF_STOCK && !product.freeProduct;
